const OWNER_AREA_PATHS = [
  "/owner-dashboard",
  "/my-properties",
  "/proposals",
  "/owner-rent-process",
];

export function isOwnerAreaPath(pathname: string): boolean {
  return OWNER_AREA_PATHS.some((path) => pathname.startsWith(path));
}
